import axios from "axios";
import qs from "qs";
import {
  Geoesbmengine,
  ServiceConfig,
  Editmanager
} from "@/config/app-config.js";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.withCredentials = true;

const GeoesbService = Geoesbmengine.location + "/services";
// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 上传检测数据大小
export const apiCheckFileSize = param => {
  return axios({
    method: "post",
    url: `${GeoesbService}/centerupload/check/file.json`,
    data: param
  });
};

// 上传数据
export const apiAddMapLayerUpload = param => {
  let url = `${GeoesbService}/centerupload/taskinstance/file`;
  return axios({
    url,
    method: "post",
    data: param
  });
};

//获取上传文件的字段
export const apiDataExcelQueryFieldNames = id => {
  return axios({
    method: "get",
    url: `${GeoesbService}/datafile/${id}/fields.json`
  });
};

// 上传检查
export const apiUploadCheckconfig = () => {
  return axios.get(`${GeoesbService}/uploadconfiguration/checkconfig.json`);
};

// 上传文件
export const apiAddUploadLayer = data => {
  return axios({
    url: `${GeoesbService}/centerupload/taskinstance/add.json`,
    method: "post",
    data: data
  });
};

//上传excel生成数据集
export const apiUpdateDatasetExcelField = (id, params) => {
  let url = `${GeoesbService}/centerupload/taskinstance/dataseteditfile/${id}.json`;
  return axios({
    url,
    method: "put",
    data: params
  });
};

// 获取资源根目录
export const apiGetDistrictCatalog = params => {
  return axios.get(`${GeoesbService}/servicemanager/district/child.json`, {
    params: params || {}
  });
};

// 获取资源子目录
export const apiGetGategotyCatalog = params => {
  return axios.get(`${GeoesbService}/catalog/gategoty/view.json`, {
    params: params || {}
  });
};

// 请求iserver地址
export const apiServerQueryUpdataDetail = datasetid => {
  return axios.get(
    `${Editmanager.location}/services/edit/datasets/${datasetid}/iserver.json`
  );
};

// 根据iserver地址请求地图信息判断是否可叠加
export const apiJudgePrjCoordSys = url => {
  // window.judgePrjCoordSys = callback;
  return axios.get(`${url}.json`, { withCredentials: false });
  // $.ajax({
  //   url: url + ".jsonp",
  //   dataType: "jsonp",
  //   type: "get",
  //   jsonpCallback: "judgePrjCoordSys",
  // });
};

// 根据iserver地址请求地图图层信息并添加到专题图
export const apiGetMapLayerName = url => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}/layers.json`);
};

//删除数据上传图层
export const apiDeleteUploadMap = (datasetId) => {
  let random = "?random=" + Math.random();
  return axios({
    method: "delete",
    url: `${Editmanager.location}/services/edit/datasets/datasetid/${datasetId}.json${random}`
  });
};

//数据上传图层下载
export const apiDownLoadUploadMap = (datasetid, type) => {
  return `${Editmanager.location}/services/edit/datasets/${datasetid}/export?type=${type}`;
};

/**
 * 在线配图 - 配图目录管理
 */
// 获取配图目录根节点
export const apiGetPictureTreeRoot = () => {
  return axios.get(`${GeoesbService}/thematic/mapcatalogs/root`);
};

// 根据目录ID获取配图目录树子节点
export const apiGetPictureTree = id => {
  return axios.get(`${GeoesbService}/thematic/mapcatalogs/tree/${id}`);
};

// 根据目录ID获取配图目录
export const apiGetPictureCatalogs = id => {
  return axios.get(`${GeoesbService}/thematic/mapcatalogs/${id}`);
};

// 添加配图目录
export const apiAddPictureCatalogs = param => {
  return axios.post(`${GeoesbService}/thematic/mapcatalogs`, param);
};

// 更新配图目录
export const apiUpdatePictureCatalogs = id => {
  return axios.put(`${GeoesbService}/thematic/mapcatalogs/${id}`);
};

// 删除配图目录
export const apiRemovePictureCatalogs = id => {
  return axios.delete(`${GeoesbService}/thematic/mapcatalogs/${id}`);
};

// 根据配图目录ID获取配图ID
export const apiGetPicture = catalogid => {
  return axios.get(`${GeoesbService}/thematic/maps/catalog/${catalogid}.json`);
};

// 根据配图ID获取配图详情
export const apiGetPictureMap = id => {
  return axios.get(`${GeoesbService}/thematic/maps/${id}.json`);
};

// 配图收藏
export const apiPictureMapCollect = (mapid, option) => {
  return axios.post(
    `${GeoesbService}/servicemanager/bookmark/thematic/${mapid}.json`,
    option
  );
};

// 取消收藏
export const apiDeletePictureMapCollect = mapid => {
  return axios.delete(
    `${GeoesbService}/servicemanager/bookmark/thematic/${mapid}.json`
  );
};

/**
 * 在线配图 - 专题风格
 */
// 根据服务ID/数据上传的数据集ID获取配图详情
export const apiGetPictureByResourceId = option => {
  return axios.get(
    `${GeoesbService}/thematic/maps/resource.json?resourceId=${option.resourceId}&resourceType=${option.resourceType}`
  );
};

// 配图名称查重
export const apiCheckPictureMap = option => {
  return axios.get(
    `${GeoesbService}/thematic/maps/checkrepeat.json?id=${option.id}&name=${option.name}`
  );
};

// 设置默认配图
export const apiSetDefaultPictureMap = option => {
  return axios.post(
    `${GeoesbService}/thematic/maps/default/${option.mapid}/resource/${option.resourceid}/${option.resourcetype}`
  );
};
//取消默认配图
export const apiCancelDefaultPictureMap = option => {
  return axios.delete(
    `${GeoesbService}/thematic/maps/default/${option.mapid}/resource/${option.resourceid}/${option.resourcetype}`
  );
};

/**
 * 在线配图 - 配图管理
 */
// 添加配图
export const apiAddPictureMap = param => {
  return axios.post(`${GeoesbService}/thematic/maps.json`, param);
};

// 更新配图
export const apiUpdatePictureMap = (id, params) => {
  return axios({
    method: "put",
    url: `${GeoesbService}/thematic/maps/${id}.json`,
    data: params
  });
};

// 删除配图
export const apiRemovePictureMap = id => {
  return axios.delete(`${GeoesbService}/thematic/maps/${id}.json`);
};

// 配图共享/取消共享
export const apiSharePictureMap = (mapid, param) => {
  return axios.post(`${GeoesbService}/thematic/maps/${mapid}/share`, param);
};

// 配图共享部门用户查询
export const apiGetUserByDepid = depid => {
  return axios.get(
    `${GeoesbService}/servicemanager/user/deptusers.json?depid=${depid}`
  );
};

// 获取已分享的用户列表
export const apiGetShareUser = mapid => {
  return axios.get(`${GeoesbService}/thematic/maps/${mapid}/share`);
};

/**
 * 在线配图 - 符号库管理
 */
// 添加分组
export const apiPostSymbolGroups = param => {
  // {
  //   "groupName": "", //分组名称
  //   "parentGroupName": "", //父分组名称
  // }
  return axios({
    url: `${GeoesbService}/thematic/symbolmanage/groups.json`,
    method: "post",
    data: param
  });
};

// 更新分组
export const apiPutSymbolGroups = param => {
  // {
  //   "oldGroupName": "旧的分组名称", //旧的分组名称
  //   "groupName": "", //分组名称
  //   "parentGroupName": "", //父分组名称
  // }
  return axios({
    url: `${GeoesbService}/thematic/symbolmanage/groups.json`,
    method: "put",
    data: param
  });
};

// 删除分组
export const apiDelSymbolGroups = param => {
  // {
  //   "groupName": "", //分组名称
  //   "parentGroupName": "", //父分组名称
  // }
  return axios({
    url: `${GeoesbService}/thematic/symbolmanage/groups.json`,
    method: "delete",
    data: param
  });
};

// 获取指定分组下的所有符号
export const apiGetSymbolByGroups = param => {
  // {
  //   "groupName": "", //分组名称
  //   "parentGroupName": "", //父分组名称
  // }
  return axios({
    url: `${GeoesbService}/thematic/symbolmanage/symbols/groupsymbols.json`,
    method: "get",
    params: param
  });
};

// 添加符号
export const apiPostSymbol = param => {
  // {
  //   "groupName": "测试分组", //分组名称
  //   "parentGroupName": "父分组名称", //父分组名称
  //   "symbolType": 0, //符号库类型0/1/2=》点，线，填充
  //   "files": [], //上传的图片或svg文件集合
  // }
  return axios({
    url: `${GeoesbService}/thematic/symbolmanage/symbols.json`,
    method: "post",
    data: param
  });
};

// 更新符号
export const apiPutSymbol = (param) => {
  // {
  //   "symbolId": 17800, //符号ID
  //   "symbolName": [], //符号名称
  //   "symbolType": 0, 符号库类型0/1/2=》点，线，填充
  // }
  return axios({
    url: `${GeoesbService}/thematic/symbolmanage/symbols.json`,
    method: "put",
    data: param
  });
};

// 删除符号
export const apiDelSymbol = (symbolType, ids) => {
  // {
  //   "symbolType": 0, 符号库类型0/1/2=》点，线，填充
  //   "ids": [] //删除的符号id集合
  // }
  return axios({
    url: `${GeoesbService}/thematic/symbolmanage/symbols/${symbolType}.json`,
    method: "delete",
    headers: {
      "Content-Type": "application/json"
    },
    data: JSON.stringify(ids)
  });
};

// 获取点 / 线 / 填充符号库;
export const apiGetSymbolTreeList = symboltype => {
  // {
  //   "symbolId": 17800, //符号ID
  //   "symbolName": [], //符号名称
  //   "symbolImage": file //新的图片或svg
  // }
  return axios.get(`${GeoesbService}/thematic/symbolmanage/symbols/all.json`);
};

/**
 * 在线配图 - 资源注册
 */
// 资源判重
export const checkResRepeat = params => {
  let url = `${GeoesbService}/resource/checkReapeat.json?distcode=${params.distcode}&speccode=${params.speccode}&resourcename=${params.resourcename}&deptthemecode=${params.deptthemecode}`;
  return axios.get(url);
};

// 注册服务
export const registService = data => {
  return axios.post(`${GeoesbService}/resource/metadata/full.json`, data, {
    headers: { "Content-Type": "application/xml" }
  });
};

// 资源新增服务
export const resourceAddService = (resourceid, data) => {
  return axios.post(`${GeoesbService}/resource/${resourceid}.json`, data);
};



// WEBPACK FOOTER //
// ./src/apis/mapedit-api.js